import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { Button } from "reactstrap";
import { useMeCore } from "../../../cores/me";
import CenterModal from "../../layout/CenterModal";
import DemoRequestForm from "./DemoRequestForm";
import "./DemoRequest.scss";

const dismissedKey = (userId?: string) => `wembii_demo_dismissed_${userId || "anon"}`;
const requestedKey = (userId?: string) => `wembii_demo_requested_${userId || "anon"}`;

export default function DemoRequestBanner() {
  const intl = useIntl();
  const { user, company } = useMeCore();

  const initialHidden = useMemo(() => {
    try {
      return (
        localStorage.getItem(dismissedKey(user?.id)) === "1" ||
        localStorage.getItem(requestedKey(user?.id)) === "1"
      );
    } catch {
      return false;
    }
  }, [user]);

  const [hidden, setHidden] = useState(initialHidden);
  const [open, setOpen] = useState(false);

  const onDismiss = useCallback(() => {
    try {
      localStorage.setItem(dismissedKey(user?.id), "1");
    } catch {}
    setHidden(true);
  }, [user]);

  const onRequested = useCallback(() => {
    try {
      localStorage.setItem(requestedKey(user?.id), "1");
    } catch {}
    setOpen(false);
    setHidden(true);
  }, [user]);

  if (hidden) return null;

  return (
    <>
      <div className="demo-banner">
        <div className="demo-banner__text">
          <p className="demo-banner__title">
            <FontAwesomeIcon icon={faCalendarCheck} className="mr-2" />
            {intl.formatMessage({ id: "app.demo.banner.title" })}
          </p>
          <p className="demo-banner__subtitle">
            {intl.formatMessage({ id: "app.demo.banner.subtitle" })}
          </p>
        </div>
        <div className="demo-banner__actions">
          <Button
            color="primary"
            className="demo-banner__cta"
            onClick={() => setOpen(true)}
          >
            {intl.formatMessage({ id: "app.demo.banner.cta" })}
          </Button>
          <Button
            color="link"
            className="demo-banner__dismiss"
            onClick={onDismiss}
          >
            {intl.formatMessage({ id: "app.demo.banner.dismiss" })}
          </Button>
        </div>
      </div>

      <CenterModal
        active={open}
        visible={open}
        size="md"
        onClose={() => setOpen(false)}
      >
        <div className="demo-step">
          <h5 className="demo-step__title">
            {intl.formatMessage({ id: "app.demo.step.title" })}
          </h5>
          <p className="demo-step__subtitle">
            {intl.formatMessage({ id: "app.demo.step.subtitle" })}
          </p>
          <DemoRequestForm
            companyId={company?.id}
            companyName={company?.name}
            defaultEmail={user?.email || ""}
            defaultPhone={user?.phoneNumber || ""}
            onSubmitted={onRequested}
          />
        </div>
      </CenterModal>
    </>
  );
}
